var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _vm.value.Contact
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "8" } },
                    [
                      _c("app-info-input", {
                        attrs: {
                          value: _vm.value.Contact.getDisplayName(),
                          label: _vm.$ct("supplier"),
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "4" } },
                    [
                      _c("app-info-input", {
                        attrs: {
                          value: _vm.value.Contact.ComputedFriendlyID,
                          label: _vm.$ct("supplier-number"),
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }